package fr.manyverse.app.domain.model

/**
 * Platform-agnostic representation of image data for upload.
 */
data class ImageData(
    val bytes: ByteArray,
    val mimeType: String,
    val fileName: String
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        other as ImageData
        return bytes.contentEquals(other.bytes) && mimeType == other.mimeType && fileName == other.fileName
    }

    override fun hashCode(): Int {
        var result = bytes.contentHashCode()
        result = 31 * result + mimeType.hashCode()
        result = 31 * result + fileName.hashCode()
        return result
    }
}
